import { Component, Input, OnInit } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { BusinessHistoryCategory } from '../../common/enums/business-history-category.enum';

import { NgIf } from '@angular/common';
import { Subject } from 'rxjs';
import { getEnterpriseLabels } from '../../common/utils/enterprise-labels.util';
import { SecurityDomain } from '../../common/enums/security-domain';
import { AuditLogTableComponent } from '../audit-log-table/audit-log-table.component';
import { AuditLogFilterComponent } from '../audit-log-filter/audit-log-filter.component';
import { AuditEventSearchRequestDto } from '../../common/interfaces/audit-event-search-request-dto';

@Component({
    selector: 'lib-business-history',
    imports: [
        Dialog,
        NgIf,
        AuditLogTableComponent,
        AuditLogFilterComponent
    ],
    standalone: true,
    templateUrl: './business-history.component.html',
    styleUrl: './business-history.component.scss'
})
export class BusinessHistoryComponent implements OnInit {
    @Input() enterpriseId = 0;
    @Input() enterpriseLabels = getEnterpriseLabels(SecurityDomain.MODMED);
    @Input() eventCategory: BusinessHistoryCategory = BusinessHistoryCategory.USERS;

    searchRequest: AuditEventSearchRequestDto = {} as AuditEventSearchRequestDto;
    displayHistory = false;
    auditLogFilterSubject = new Subject<AuditEventSearchRequestDto>;
    dataIdentifierPrefix = 'businesshistory';

    ngOnInit(): void {
        this.dataIdentifierPrefix = this.eventCategory ? this.eventCategory.toLowerCase() + '-' + this.dataIdentifierPrefix : this.dataIdentifierPrefix;
    }

    handleFilterChange(searchRequest: AuditEventSearchRequestDto): void {
        this.auditLogFilterSubject.next(searchRequest);
    }
}
